import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { ErrorHandlerService } from '../shared/services/error-handler.service';
import {TokenService} from "../pages/auth/services/token.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private token: TokenService,
    private router: Router,
    private errorHandler: ErrorHandlerService,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const skipAuthForProjectSubKeys =
      request.method === 'GET' &&
      request.url.includes('/api/me/sub-keys') &&
      !request.url.includes('/by-master'); // List sub-keys uses project API key as bearer

    if (
      request.url.includes('auth') ||
      request.url.includes('registration') ||
      request.url.includes('social') ||
      (request.url.includes('password') && !request.url.includes('password/update')) ||
      request.url.includes('geoserver') ||
      request.url.includes('search/ownershiptype/list') ||
      request.url.includes('search/desa/list') ||
      request.url.includes('search/kabupaten/list') ||
      request.url.includes('assets/icons') ||
      request.url.includes('/api/me/sub-keys') || // Sub-keys API uses project API keys, not user JWT
      request.url.includes('/perare-api/v1/') || // Perare API endpoints use different authentication
      request.url.includes('/widgets') || // Dashboard widgets API uses project API keys
      request.url.includes('/dashboard-templates') || // Dashboard templates API uses project API keys
      request.url.includes('/dashboards') || // Dashboards API uses project API keys
      skipAuthForProjectSubKeys
    ) {
      return next.handle(request);
    }

    const token = this.token.getTokenAsGuestOrNormal();

    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
      return next.handle(request).pipe(
        catchError((err: any) => {
          // Special handling for metric endpoint - don't redirect or show errors
          if (request.url.includes('/api/metric')) {
            return throwError(err);
          }

          if (err.error?.code === 401 && !request.url.includes('password/update')) {
            this.errorHandler.handleError(err);
            this.router.navigate(['auth']);
          } else if (err.status === 401 && !request.url.includes('password/update')) {
            this.errorHandler.handleError(err);
            this.router.navigate(['auth']);
          } else if (err.status === 429) {
            // Handle rate limiting errors (PERARE-PROD-G3/GH fix)
            console.warn('Rate limit exceeded for request:', request.url);
            // Don't show error to user for rate limiting, let components handle gracefully
            // The backend should return appropriate retry-after headers
          }
          return throwError(err);
        }),
      );
    }

    return next.handle(request);
  }
}
